import passkeyDefaultSrc from '@corbado/shared-ui/assets/passkey-default.svg';
import { memo, useRef } from 'react';
import React from 'react';
import { useIconWithTheme } from '../../../hooks/useIconWithTheme';
import { Icon } from './Icon';
export const PasskeyDefaultIcon = memo(props => {
    const svgRef = useRef(null);
    const { logoSVG } = useIconWithTheme(svgRef, passkeyDefaultSrc);
    return (React.createElement(Icon, { src: logoSVG, ref: svgRef, alt: 'passkey-default', ...props }));
});
